const BANDERAS_HARDCODED_YPF = {
  idBandera: 3,
  nombre: "sinBandera",//"ypf", //"YPF",
};

const getBanderas = async () => {
  return BANDERAS_HARDCODED_YPF;
};

const banderas = {
  getBanderas,
};

export default banderas;
